<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VOE31b/tc-custom/9781035818556.jpg?1718017967108" alt="This image is the cover for the book The Itch That Couldn't Be Scratched"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Itch That Couldn't Be Scratched
      </h1>
      <p class="bookDescription body article font2">
        <p>Ed and Jess are happy in retirement – that is, until their lives are forever changed when they witness a woman take her own life. Why did she do it? The police aren’t investigating and no one seems to care. But Ed and Jess do, and they’re determined to uncover the truth behind her tragic act. Their investigation soon reveals a pandora’s box that includes war crimes, criminal conspiracies, police corruption and a pervasive need for justice left unfulfilled. Can this ordinary elderly couple succeed where officials refuse to tread? The deeper Ed digs, the more strain it puts on his marriage as Jess grows fearful of the dangers involved. Yet despite tensions at home and sinister forces working against them, Ed persists, compelled by his conscience to see this through to the end. His good intentions pave an unpredictable path filled with chance encounters, family complications, and life-threatening risks. Will Ed unravel the mystery in time or will his obsession bring disaster upon himself and those close to him? One thing’s for sure: he has no plans to stop until justice is served.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeff Senior
      </h2>
      
      <p class="authorDescription body article">Jeff Senior was born in West Yorkshire in 1949 and continues to live there with Freda, his wife for many years. He has two sons and two grandchildren. He had a long career in IT, latterly as a freelance technical author, and then moved on to writing articles for various business magazines. Jeff is semi-retired, so he has the time to develop his writing further. This is his first published novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6e435db9